// extracted by mini-css-extract-plugin
export default {"text":"Statute_text__nliIi"};